import styled from 'styled-components';

export const StyledQualityMarkPage = styled('div')`
  .page-content {
    padding-bottom: 80px;
  }

  .page-footer {
    position: fixed;
    width: -webkit-fill-available;
  }
`;
